import styled from 'styled-components'

const CardSubtitle = styled.div`
  margin: 0;
  font-size: 14px;
`

export default CardSubtitle
